export const SET_BANK_DATA = 'SET_BANK_DATA';
export const SET_MANDATE_DATA = 'SET_MANDATE_DATA';
